import { Typography } from '@mui/material';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useSnackbar } from '@Providers/useSnackbar';
import AssignmentSubmissionCard from '../../StandaloneCourses/Submissions/AssignmentSubmissionCard';
import SubmissionModal from '../../StandaloneCourses/Submissions/SubmissionModal';
import { endpointsForCourse } from '../../StandaloneCourses/Submissions/endpoints';
import { AssignmentSubmission } from '../../StandaloneCourses/Submissions/Submissions.types';
import usePagedSubmissions from '../Hooks/usePagedSubmissions';
import SubmissionsPager from './SubmissionsPager';
import { SubmissionsFilters, fetchAssignmentSubmissions } from '../Services/submissions.req';

type Props = {
	filters: SubmissionsFilters;
	canGrade: boolean;
	onChanged: () => void;
};

const GlobalAssignmentSubmissions: React.FC<Props> = ({ filters, canGrade, onChanged }) => {
	const { displaySnackbar } = useSnackbar();
	const [current, setCurrent] = useState<AssignmentSubmission>();
	const { page, setPage, rows, meta, reload } = usePagedSubmissions(
		(activePage) => fetchAssignmentSubmissions(filters, activePage),
		[filters],
		(error: any) => displaySnackbar('error', error?.response?.data?.message ?? 'Unable to load assignment submissions')
	);

	const closeModal = () => {
		setCurrent(undefined);
		reload();
		onChanged();
	};

	return (
		<div>
			{current && (
				<SubmissionModal
					open
					submission={current}
					endpoints={endpointsForCourse(current.assignment.unit.course)}
					readOnly={!canGrade}
					onClose={closeModal}
				/>
			)}
			{rows.length === 0 ? (
				<Empty>{filters.state === 'pending' ? 'No assignment submissions awaiting review' : 'No assignment submissions'}</Empty>
			) : (
				rows.map((row) => (
					<AssignmentSubmissionCard
						key={row.id}
						submission={row}
						showProduct
						actionLabel={canGrade ? (row.score == null ? 'Score' : 'Regrade') : 'View'}
						onClick={(submission) => setCurrent(submission)}
					/>
				))
			)}
			<SubmissionsPager meta={meta} page={page} shown={rows.length} onChange={setPage} />
		</div>
	);
};

const Empty = styled(Typography)`
	color: #a4a4a4;
	padding: 2rem 0;
	text-align: center;
`;

export default GlobalAssignmentSubmissions;
